import { DsAccordionOverrides, DsAccordionActionsOverrides, DsAccordionDetailsOverrides, DsAccordionSummaryOverrides, DsAppBarOverrides, DsAutocompleteOverrides, DsAvatarOverrides, DsAvatarGroupOverrides, DsBackdropOverrides, DsBadgeOverrides, DsBottomNavigationOverrides, DsBottomNavigationActionOverrides, DsBottomSheetOverrides, DsBoxOverrides, DsBreadcrumbsOverrides, DsButtonOverrides, DsButtonBaseOverrides, DsButtonGroupOverrides, DsCardOverrides, DsCardActionAreaOverrides, DsCardActionsOverrides, DsCardContentOverrides, DsCardHeaderOverrides, DsCardMediaOverrides, DsCarouselOverrides, DsCheckboxOverrides, DsChipOverrides, DsChipGroupOverrides, DsCircularProgressOverrides, DsClickAwayListenerOverrides, DsCollapseOverrides, DsContainerOverrides, DsCssBaselineOverrides, DsDialogOverrides, DsDialogActionsOverrides, DsDialogContentOverrides, DsDialogContentTextOverrides, DsDialogTitleOverrides, DsDividerOverrides, DsDrawerOverrides, DsFabOverrides, DsFadeOverrides, DsFileUploaderOverrides, DsFilledInputOverrides, DsFormControlOverrides, DsFormControlLabelOverrides, DsFormGroupOverrides, DsFormHelperTextOverrides, DsFormLabelOverrides, DsGlobalStylesOverrides, DsGridOverrides, DsGrowOverrides, DsHeaderOverrides, DsHelperTextOverrides, DsIconOverrides, DsIconButtonOverrides, DsImageOverrides, DsImageListOverrides, DsImageListItemOverrides, DsImageListItemBarOverrides, DsInputOverrides, DsInputAdornmentOverrides, DsInputBaseOverrides, DsInputLabelOverrides, DsLinearProgressOverrides, DsLinkOverrides, DsListOverrides, DsListItemOverrides, DsListItemAvatarOverrides, DsListItemButtonOverrides, DsListItemIconOverrides, DsListItemSecondaryActionOverrides, DsListItemTextOverrides, DsListSubheaderOverrides, DsLoaderOverrides, DsMenuOverrides, DsMenuItemOverrides, DsMenuListOverrides, DsMobileStepperOverrides, DsModalOverrides, DsNativeSelectOverrides, DsNoSsrOverrides, DsNotistackOverrides, DsOtpOverrides, DsOutlinedInputOverrides, DsPaginationOverrides, DsPaginationItemOverrides, DsPaperOverrides, DsPopoverOverrides, DsPopperOverrides, DsPopupOverrides, DsPortalOverrides, DsProgressIndicatorOverrides, DsProgressTrackerOverrides, DsRadioOverrides, DsRadioGroupOverrides, DsRatingOverrides, DsRemixIconOverrides, DsScopedCssBaselineOverrides, DsSearchbarOverrides, DsSelectOverrides, DsSkeletonOverrides, DsSlideOverrides, DsSliderOverrides, DsSpeedDialOverrides, DsSpeedDialActionOverrides, DsSpeedDialIconOverrides, DsStackOverrides, DsStepOverrides, DsStepButtonOverrides, DsStepConnectorOverrides, DsStepContentOverrides, DsStepIconOverrides, DsStepLabelOverrides, DsStepperOverrides, DsSvgIconOverrides, DsSwipeableDrawerOverrides, DsSwitchOverrides, DsTabOverrides, DsTabScrollButtonOverrides, DsTableOverrides, DsTableBodyOverrides, DsTableCellOverrides, DsTableContainerOverrides, DsTableFooterOverrides, DsTableHeadOverrides, DsTablePaginationOverrides, DsTableRowOverrides, DsTableSortLabelOverrides, DsTabsOverrides, DsTagOverrides, DsTagGroupOverrides, DsTextAreaOverrides, DsTextFieldOverrides, DsTextFieldPasswordOverrides, DsTextareaAutosizeOverrides, DsToastOverrides, DsToggleOverrides, DsToggleButtonOverrides, DsToggleButtonGroupOverrides, DsToolbarOverrides, DsTooltipOverrides, DsTypographyOverrides, DsZoomOverrides, DsDatePickerOverrides } from '../Components';
const componentOverrides = {
    ...DsAccordionOverrides,
    ...DsAccordionActionsOverrides,
    ...DsAccordionDetailsOverrides,
    ...DsAccordionSummaryOverrides,
    ...DsAppBarOverrides,
    ...DsAutocompleteOverrides,
    ...DsAvatarOverrides,
    ...DsAvatarGroupOverrides,
    ...DsBackdropOverrides,
    ...DsBadgeOverrides,
    ...DsBottomNavigationOverrides,
    ...DsBottomNavigationActionOverrides,
    ...DsBottomSheetOverrides,
    ...DsBoxOverrides,
    ...DsBreadcrumbsOverrides,
    ...DsButtonOverrides,
    ...DsButtonBaseOverrides,
    ...DsButtonGroupOverrides,
    ...DsCardOverrides,
    ...DsCardActionAreaOverrides,
    ...DsCardActionsOverrides,
    ...DsCardContentOverrides,
    ...DsCardHeaderOverrides,
    ...DsCardMediaOverrides,
    ...DsCarouselOverrides,
    ...DsCheckboxOverrides,
    ...DsChipOverrides,
    ...DsChipGroupOverrides,
    ...DsCircularProgressOverrides,
    ...DsClickAwayListenerOverrides,
    ...DsCollapseOverrides,
    ...DsContainerOverrides,
    ...DsCssBaselineOverrides,
    ...DsDatePickerOverrides,
    ...DsDialogOverrides,
    ...DsDialogActionsOverrides,
    ...DsDialogContentOverrides,
    ...DsDialogContentTextOverrides,
    ...DsDialogTitleOverrides,
    ...DsDividerOverrides,
    ...DsDrawerOverrides,
    ...DsFabOverrides,
    ...DsFadeOverrides,
    ...DsFileUploaderOverrides,
    ...DsFilledInputOverrides,
    ...DsFormControlOverrides,
    ...DsFormControlLabelOverrides,
    ...DsFormGroupOverrides,
    ...DsFormHelperTextOverrides,
    ...DsFormLabelOverrides,
    ...DsGlobalStylesOverrides,
    ...DsGridOverrides,
    ...DsGrowOverrides,
    ...DsHeaderOverrides,
    ...DsHelperTextOverrides,
    ...DsIconOverrides,
    ...DsIconButtonOverrides,
    ...DsImageOverrides,
    ...DsImageListOverrides,
    ...DsImageListItemOverrides,
    ...DsImageListItemBarOverrides,
    ...DsInputOverrides,
    ...DsInputAdornmentOverrides,
    ...DsInputBaseOverrides,
    ...DsInputLabelOverrides,
    ...DsLinearProgressOverrides,
    ...DsLinkOverrides,
    ...DsListOverrides,
    ...DsListItemOverrides,
    ...DsListItemAvatarOverrides,
    ...DsListItemButtonOverrides,
    ...DsListItemIconOverrides,
    ...DsListItemSecondaryActionOverrides,
    ...DsListItemTextOverrides,
    ...DsListSubheaderOverrides,
    ...DsLoaderOverrides,
    ...DsMenuOverrides,
    ...DsMenuItemOverrides,
    ...DsMenuListOverrides,
    ...DsMobileStepperOverrides,
    ...DsModalOverrides,
    ...DsNativeSelectOverrides,
    ...DsNoSsrOverrides,
    ...DsNotistackOverrides,
    ...DsOtpOverrides,
    ...DsOutlinedInputOverrides,
    ...DsPaginationOverrides,
    ...DsPaginationItemOverrides,
    ...DsPaperOverrides,
    ...DsPopoverOverrides,
    ...DsPopperOverrides,
    ...DsPopupOverrides,
    ...DsPortalOverrides,
    ...DsProgressIndicatorOverrides,
    ...DsProgressTrackerOverrides,
    ...DsRadioOverrides,
    ...DsRadioGroupOverrides,
    ...DsRatingOverrides,
    ...DsRemixIconOverrides,
    ...DsScopedCssBaselineOverrides,
    ...DsSearchbarOverrides,
    ...DsSelectOverrides,
    ...DsSkeletonOverrides,
    ...DsSlideOverrides,
    ...DsSliderOverrides,
    ...DsSpeedDialOverrides,
    ...DsSpeedDialActionOverrides,
    ...DsSpeedDialIconOverrides,
    ...DsStackOverrides,
    ...DsStepOverrides,
    ...DsStepButtonOverrides,
    ...DsStepConnectorOverrides,
    ...DsStepContentOverrides,
    ...DsStepIconOverrides,
    ...DsStepLabelOverrides,
    ...DsStepperOverrides,
    ...DsSvgIconOverrides,
    ...DsSwipeableDrawerOverrides,
    ...DsSwitchOverrides,
    ...DsTabOverrides,
    ...DsTabScrollButtonOverrides,
    ...DsTableOverrides,
    ...DsTableBodyOverrides,
    ...DsTableCellOverrides,
    ...DsTableContainerOverrides,
    ...DsTableFooterOverrides,
    ...DsTableHeadOverrides,
    ...DsTablePaginationOverrides,
    ...DsTableRowOverrides,
    ...DsTableSortLabelOverrides,
    ...DsTabsOverrides,
    ...DsTagOverrides,
    ...DsTagGroupOverrides,
    ...DsTextAreaOverrides,
    ...DsTextFieldOverrides,
    ...DsTextFieldPasswordOverrides,
    ...DsTextareaAutosizeOverrides,
    ...DsToastOverrides,
    ...DsToggleOverrides,
    ...DsToggleButtonOverrides,
    ...DsToggleButtonGroupOverrides,
    ...DsToolbarOverrides,
    ...DsTooltipOverrides,
    ...DsTypographyOverrides,
    ...DsZoomOverrides
};
export default componentOverrides;
